import { Injectable } from '@angular/core';
import { UserDataService } from './user-data.service';
import { Router } from '@angular/router';
import { NavigationShareService } from './navigation-share.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {

  constructor(private userData: UserDataService, private router: Router, private shareService: NavigationShareService) {
  }

  // Returns -1 if user is done with onboarding or step number that is not completed
  checkStatus(): -1 | 1 | 2 | 3 {
    // Onboarding step 1 check -> User data
    if (!this.userData.getUser()?.first_name || !this.userData.getUser()?.last_name || this.userData.getUser()?.role === "UNDEFINED") {
      this.shareService.setState("email", this.userData.getUser()?.email);
      this.shareService.setState("socialLogin", true);
      return 1;
    }

    // Onboarding step 2 check -> Company creation
    if (!this.userData.getUser()?.company) {
      return 2;
    }

    // Onboarding step 3 check -> Workspace preferences
    if (!this.userData.getUser()?.settings?.workspace_preferences) {
      return 3;
    }

    //Onboarding is completed
    return -1;
  }

  redirectToOnboarding(): boolean {
    const onboardingStep = this.checkStatus();

    if (onboardingStep == -1) {
      return false;
    }

    this.router.navigate(['/auth/onboarding'], { queryParams: { step: onboardingStep } });
    return true;
  }
}
